import SubcategorySection from 'pages/CatalogPage/DH/SubcategorySection/SubcategorySection';

export default SubcategorySection;
